"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var ENDPOINT_URL = '/upgrade-catalog/v1/purchase-orders/offer-builder';
var offerBuilderApi = {
  put: function put(_ref) {
    var offerPayload = _ref.offerPayload,
        currencyCode = _ref.currencyCode;
    return _apiClient.default.put(ENDPOINT_URL, {
      query: {
        'currency-code': currencyCode
      },
      data: offerPayload
    });
  }
};
var _default = offerBuilderApi;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/core/api/offerBuilderApi.js
// module id = 719
// module chunks = 5 6